module.exports = __webpack_public_path__ + "static/media/cerisaie01.c3ab66ab.jpg";